export default "__VITE_PUBLIC_ASSET__ceda16c1__"